import { useEffect, useState } from "react";
import { NAV } from "@/constants/testIds";
import { motion } from "framer-motion";

const links = [
  { label: "About", target: "/#about", id: NAV.linkAbout },
  { label: "Consulting", target: "/industrial-project-management-consultant-india/", id: NAV.linkExpert },
  { label: "Board Practice", target: "/independent-director-industrial-sector/", id: NAV.linkWhy },
  { label: "Insights", target: "/insights/", id: NAV.linkPractice },
  { label: "Contact", target: "/#contact", id: NAV.linkContact },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const next = window.scrollY > 40;
      setScrolled((current) => (current === next ? current : next));
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-ink/95 border-b border-surface-2" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 h-20 flex items-center justify-between">
        <a href="/" data-testid={NAV.logo} className="flex items-center gap-3 group">
          <span className="h-2 w-2 bg-brass block" />
          <span className="font-serif-display text-ivory text-xl tracking-tight">
            Asad Hatimi<span className="text-brass">.</span>
          </span>
        </a>
        <div className="hidden md:flex items-center gap-10 text-[11px] uppercase tracking-[0.22em] text-ivory/80">
          {links.map((l) => (
            <a key={l.label} href={l.target} data-testid={l.id} className="link-underline hover:text-brass">
              {l.label}
            </a>
          ))}
        </div>
        <a
          href="/Asad_Hatimi_CV.pdf"
          download
          data-testid={NAV.downloadCv}
          className="hidden md:inline-flex items-center gap-2 border border-brass/60 px-5 py-2.5 text-[11px] uppercase tracking-[0.22em] text-brass hover:bg-brass hover:text-ink transition-colors duration-500"
        >
          CV / PDF
        </a>
      </div>
    </motion.nav>
  );
}
